import { useContext } from 'react';
import { Link } from 'react-router-dom';
import ThemeContext from '../context/ThemeContext';
import '../styles/Footer.css';

const Footer = () => {
  const images = "edit icon.png";
  const { accentColor } = useContext(ThemeContext);

  return (
    <div 
      className="footer" 
      style={{ background: accentColor, padding: '20px 10px' }}
    >
      <div className="boundless">
        <hr className="newLine" />

        <div className="footerContent">

          {/* Left Side – Icon */}
          <a 
            href="https://youtu.be/Nk_yuWyxPXs"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img 
              src={`/${images}`} 
              alt="EditFarmer Icon"
              className="theIcon"
            />
          </a>

          {/* Right Side – Legal Links */}
          <div className="footerLinks">
            <Link className="footman " to="/terms"> Terms of Service | </Link>
            <Link to="/privacy"> Privacy Policy | </Link>
            <Link to="/refund"> Refund Policy | </Link>
            <Link to="/contact">Contact</Link>
          </div>

        </div>
      </div>
    </div>
  );
};

export default Footer;
